import dynamic from 'next/dynamic';

/**
 * Lazy load a component on the client using Next dynamic imports
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadable = (loader: () => Promise<any>) => dynamic(loader, { ssr: false });
